<template>
  <div class="homebg">
    <div class="home">
      <div class="startbg" v-if="feng">
        <img :src="fengbg" class="startbg" @click="tomp4" alt="">
        <!-- <img src="../static/bar.gif" v-if="bar" class="bar" alt=""> -->
      </div>

      <div v-show="!end" >
        <video-player class="video-player vjs-custom-skin playerA"   @ended="onPlayerEnded($event)"
          @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" ref="videoPlayerA" :playsinline="true" :options="playerOptionsA" >
        </video-player>
        <div class="stop" @click="ifplay"><p class="ifplay">点击画面 暂停/播放</p> </div>
        <!-- <img src="../static/skip.png" class="skip" v-if="start" @click="skip" alt=""> -->
      </div>



    </div>
    <div class="endbg" v-show="end">
      <img src="@/static/end.gif" class="end" alt="">
      <div @click="tosence" class="tosence"> </div>
      <div class="ding1" @click="showding(1)"></div>
      <div class="ding2" @click="showding(2)"></div>
      <div class="ding3" @click="showding(3)"></div>
      <div class="ding-box" v-if="ding == 1">
        <img src="../static/1.png" class="ding" alt="">
        <div class="back" @click="back"></div>
      </div>
      <div class="ding-box" v-if="ding == 2">
        <img src="../static/2.png" class="ding" alt="">
        <div class="back1" @click="back"></div>
      </div>
      <div class="ding-box" v-if="ding == 3">
        <img src="../static/3.png" class="ding" alt="">
        <div class="back2" @click="back"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bar: false,
      feng: true,
      start: false,
      ifpause:false,
      ding: 0,
      fengbg: require("../static/feng.gif"),
      playerOptionsA: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("../static/yjgcc.mp4"), //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: false, // 当前时间和持续时间的分隔符
          durationDisplay: false, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能

          fullscreenToggle: false, //全屏按钮
        },
      },
      end: false
    }
  },
  methods: {
    showding(a) {
      this.ding = a
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    ifplay() {
     
      
      if (this.ifpause==true) {
        this.$refs.videoPlayerA.player.play();
        this.ifpause=false
      } else {
        this.$refs.videoPlayerA.player.pause();
        this.ifpause=true
      }
    },
    back() {
      this.ding = 0
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    onPlayerPause(e){
      console.log("暂停")
    },
    onPlayerEnded(e) {
      console.log("播放结束", e);
      this.end = true
    },
    tosence() {
      this.$router.push("sence")
    },
    onPlayerPlay(e) {
      this.start = true

    },
    skip() {
      this.$refs.videoPlayerA.player.pause();
      this.end = true

    },
    tomp4() {
      this.feng = false
      this.$refs.videoPlayerA.player.play();
      // this.fengbg=require("../static/feng2.gif")
      // this.bar=true
      // setTimeout(() => {
      //   this.feng=false
      //   this.$refs.videoPlayerA.player.play();
      // }, 3500);
    }
  },
  mounted() {

    // this.$refs.videoPlayerA.player.play()
    // video.addEventListener("ended",function(){
    //   console.log("播放结束");
    // })
  }


}
</script>

<style lang="less">
.homebg {
  position: relative;
  width: 100%;

  .home {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100vh;
    // height: 280vh;
    // background: url("../static/middle.png") top center no-repeat;
    // background-size: 100% 100%;
    background-color: #e8e4e486;
    // height: 100vh;

    .feng {
      width: 100vw;
      margin: 0 auto;
      text-align: center;
    }

    .skip {
      position: absolute;
      right: 20px;
      top: 10px;
      height: 40px;
      z-index: 6;
    }
    .stop{
      position: absolute;
      width: 100vw;
      height: 100vh;
      top: 0;
      background-color: #e8e4e436;
      z-index: 6;
    
      .ifplay{
        position: absolute;
        bottom: 25px;
        font-size: 13px;
        background-color: #ffffff83;
        border-radius: 20px;
        padding: 3px 10px;
        border: 1.5px solid #fff;
      
        width: 120px;
        
        text-align: center;
        left: 50%;
        margin-left: -60px;
      }
    }
    .playerA {
      // margin-top: 80px;

      margin: auto auto;
      position: relative;
      display: block;
      width: 100%;
      height: 100vh;
    }

    /deep/ .video-js .vjs-tech {
      object-fit: fill;
    }

    /deep/ .vjs-poster {
      background-size: cover;
    }


    .video-js {
      background-color: transparent;
      height: 100vh;
      // width: 100%;
    }

    .vjs-poster {
      background-color: transparent;
      cursor: pointer;

    }

    .vjs-control-bar {
      display: none;
    }

    .vjs-big-play-button {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      ;
    }

    .startbg {
      position: relative;
      width: 100vw;
      margin: 0 auto;
      text-align: center;
      overflow: hidden;
      z-index: 55;

      .bar {
        position: absolute;
        bottom: 220px;
        left: 50%;
        width: 180px;
        margin-left: -90px;
        z-index: 66;
      }
    }
  }

  .endbg {
    width: 100vw;
    margin: 0 auto;
    text-align: center;
    position: absolute;
    top: 0;

    .end {
      // height: 100vh;
      width: 100vw;
      margin: 0 auto;
      display: block;
    }

    .tosence {
      position: absolute;

      width: 150px;
      height: 60px;
      top: 340px;
      left: 50%;
      margin-left: -75px;
    }

    .ding1 {
      position: absolute;
      width: 65px;
      height: 200px;

      top: 480px;
      left: 75px;
    }

    .ding2 {
      position: absolute;
      width: 65px;
      height: 200px;

      top: 480px;
      left: 155px;
    }

    .ding3 {
      position: absolute;
      width: 65px;
      height: 200px;

      top: 480px;
      left: 235px;
    }

    .ding-box {
      position: absolute;
      top: 0;

      .ding {
        width: 100vw;
      }

      .back {
        position: absolute;
        bottom: 80px;
        width: 200px;
        height: 50px;
        left: 50%;
        margin-left: -100px;

      }

      .back1 {
        position: absolute;
        bottom: 230px;
        width: 200px;
        height: 50px;
        left: 50%;
        margin-left: -100px;

      }

      .back2 {
        position: absolute;
        bottom: 85px;
        width: 200px;
        height: 50px;
        left: 50%;
        margin-left: -100px;

      }
    }
  }
}</style>